
class Memberships {

    constructor(el) {
       
        //this component links the auto-renew checkbox with the actual renew checkbox hidden in the spektrix-memberships element

        this.autoRenewButton = el.querySelector('.membership__renew-option');
        if (this.autoRenewButton) {
            this.autoRenewCheckbox = this.autoRenewButton.querySelector('input[type="checkbox"]');
            this.autoRenewCheckbox.addEventListener('change', this.handleAutoRenewChange.bind(this));
        }
        // Find the renewCheckbox inside a child spektrix-memberships element
        const spektrixMemberships = el.querySelector('spektrix-memberships');
        if (spektrixMemberships) {
            this.renewCheckbox = spektrixMemberships.querySelector('input[type="checkbox"]');
        }
        //initialize the auto-renew checkbox state in all the spektrix checkboxes
        const spektrixCheckboxes = document.querySelectorAll('input[data-set-autorenew]');
            spektrixCheckboxes.forEach(cb => {
                cb.dispatchEvent(new Event('input', { bubbles: true }));
            });

        // this.handleAutoRenewChange()

    }

    handleAutoRenewChange(event) {
        const isChecked = event.target.checked;
        // console.log(`Auto-renew option is now ${isChecked ? 'enabled' : 'disabled'}.`);
        // If the renewCheckbox exists, update its checked state
        if (this.renewCheckbox) {
            this.renewCheckbox.checked = isChecked;
            this.renewCheckbox.setAttribute('value', isChecked);
            this.renewCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
            // console.log(`Renew checkbox is now ${isChecked ? 'enabled' : 'disabled'}.`);
        }
        
    }

    
       
   



}


document.addEventListener("DOMContentLoaded", () => {
    const memberships = document.querySelectorAll(".membership__actions");

        
    if (memberships) {
        memberships.forEach((el) => {
            
            new Memberships(el);
        });
    }
});
